// extracted by mini-css-extract-plugin
export default {"card":"CardMajor_card__uJJpG","imgWrapper":"CardMajor_imgWrapper__q9X2Z","info":"CardMajor_info__933BJ"};